// Amateur Topic 2 — Breakout. Very simple English.
export default {
  title: 'Breakout',
  summary: 'When price smashes through a floor or ceiling.',
  subtopics: [
    {
      title: 'SNR Flip: SBR & RBS', scene: 'flip',
      cards: [
        { icon: '🔄', title: 'Floors and ceilings can swap', body: 'When price breaks through a level, the level often changes job. This is called an SNR flip.' },
        { icon: '⬆️', title: 'RBS', body: 'Resistance Becomes Support. The old ceiling is broken, and later it becomes the new floor, like the floor of the next storey in a building.' },
        { icon: '⬇️', title: 'SBR', body: 'Support Becomes Resistance. The old floor is broken, and later it becomes the new ceiling.' },
        { icon: '👋', title: 'The retest', body: 'Price often comes back to say "hello" to the broken level before moving on. This is called a retest. Many traders wait for it.' },
      ],
    },
    {
      title: 'Real vs Fake Breakout', scene: 'realFake',
      cards: [
        { icon: '🕯️', title: 'Look at the body', body: 'A real breakout usually has a candle BODY (the thick part) that closes beyond the level.' },
        { icon: '🪤', title: 'Wick only = trap', body: 'If only the thin wick pokes through and the body closes back inside, it is often a fake breakout (a fakeout).' },
        { icon: '⏱️', title: 'Wait for the close', body: 'A candle is not finished until its time is up. Wait for it to close before you decide.' },
        { icon: '💪', title: 'Strong is better', body: 'Big, strong candles breaking the level are better signs than tiny, weak ones. A retest that holds is an extra sign.' },
      ],
    },
    {
      title: 'Why Breakouts Matter', scene: 'whyBreakout',
      cards: [
        { icon: '🚀', title: 'The trend keeps going', body: 'When price breaks a ceiling in an uptrend, it often keeps climbing. This is called continuation.' },
        { icon: '🏔️', title: 'New highs', body: 'Breaking above resistance makes a new high. Buyers are winning, so more buyers may join in.' },
        { icon: '🕳️', title: 'New lows', body: 'Breaking below support makes a new low. Sellers are winning, so more sellers may join in.' },
        { icon: '🧯', title: 'Stay safe', body: 'Breakouts can still fail. Use a stop loss, and don\'t chase a candle that has already moved very far.' },
      ],
    },
  ],
};
